var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-12 col-md-12 col-sm-6" },
      [
        _vm.label
          ? _c("div", { class: [`text-${_vm.labelPosition}`] }, [
              _c("label", { staticClass: "input-label" }, [
                _vm._v(_vm._s(_vm.label))
              ])
            ])
          : _vm._e(),
        !_vm.canDownload && !_vm.disabled
          ? _c(
              "label",
              {
                staticClass:
                  "form-control position-relative text-center mb-0 file-input-container",
                class: {
                  "was-Invalidated": _vm.error,
                  "input-disabled": _vm.disabled
                }
              },
              [
                _c("label", { staticClass: "file-select" }, [
                  _c("em", { staticClass: "fas fa-file-plus pr-4 text-green" }),
                  _c("span", { staticClass: "font-weight-bold" }, [
                    _vm._v(" Presione aquí para anejar documento ")
                  ]),
                  _c("input", {
                    ref: "fileuploadRef",
                    attrs: {
                      accept: _vm.accept,
                      disabled: _vm.disabled,
                      type: "file"
                    },
                    on: { change: _vm.handleFileChange }
                  })
                ])
              ]
            )
          : _vm._e(),
        _vm.canDownload
          ? _c(
              "div",
              {
                staticClass:
                  "d-flex align-items-center w-100 justify-content-start"
              },
              [
                _c("div", { staticClass: "font-weight-normal" }, [
                  _c("label", { staticClass: "circle-green" }),
                  _c(
                    "label",
                    {
                      staticClass: "mb-0 text-ellipsis",
                      staticStyle: {
                        "max-width": "295px",
                        display: "inline-block"
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.fileLabel ?? _vm.name) + " ")]
                  )
                ]),
                _c(
                  "div",
                  {
                    staticClass: "d-flex flex-row-reverse ml-2",
                    class: { "button-container": _vm.hasShortStyle }
                  },
                  [
                    _vm.canDelete
                      ? _c(
                          "button",
                          {
                            staticClass: "btn outline-danger",
                            class: { "input-disabled": _vm.disabled },
                            attrs: {
                              disabled: _vm.disabled,
                              hidden: _vm.disabled,
                              type: "button"
                            },
                            on: { click: _vm.removeFile }
                          },
                          [
                            _c("i", { staticClass: "fas fa-times-circle" }),
                            !_vm.hasShortStyle
                              ? _c("span", { staticClass: "ml-1" }, [
                                  _vm._v("Eliminar")
                                ])
                              : _vm._e()
                          ]
                        )
                      : _vm._e(),
                    _vm.canDownload
                      ? _c(
                          "button",
                          {
                            staticClass: "btn outline-success mr-2 ml-2",
                            attrs: { type: "button" },
                            on: { click: _vm.downloadFile }
                          },
                          [
                            _c("i", { staticClass: "fas fa-file-download" }),
                            !_vm.hasShortStyle
                              ? _c("span", { staticClass: "ml-1" }, [
                                  _vm._v("Descargar")
                                ])
                              : _vm._e()
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ]
            )
          : _vm._e(),
        _vm.error
          ? _c("error", {
              attrs: { message: _vm.customErrorMsg, variant: "no-border" }
            })
          : _vm._e(),
        _vm.isLoadingFile && !_vm.disabled
          ? _c("div", { staticClass: "progress mt-2" }, [
              _c(
                "div",
                {
                  staticClass:
                    "progress-bar progress-bar-striped bg-success text-center",
                  style: { width: _vm.currentLoad },
                  attrs: {
                    "aria-valuemax": "100",
                    "aria-valuemin": "0",
                    "aria-valuenow": "25",
                    role: "progressbar"
                  }
                },
                [_vm._v(" " + _vm._s(this.progressLabel) + " ")]
              )
            ])
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }